import type { FeatureFromURL } from '@lib/utils/feature'
import { featureFromParams } from '@lib/utils/feature'
import { useRouter } from 'next/router'

export * from '../utils/feature'

/**
 * Returns true if the feature is enabled for the current router.
 */
export const useFeatureFromURL = (feature: FeatureFromURL) => {
    const router = useRouter()
    if (!router) return false
    return featureFromParams(feature, router)
}
